/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Cancel_DoneInputs */

const en_settings_cancel_done = /** @type {(inputs: Settings_Cancel_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscription cancelled. Access continues until ${i?.date}.`)
};

const id_settings_cancel_done = /** @type {(inputs: Settings_Cancel_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langganan dibatalkan. Akses tetap sampai ${i?.date}.`)
};

/**
* | output |
* | --- |
* | "Subscription cancelled. Access continues until {date}." |
*
* @param {Settings_Cancel_DoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_done = /** @type {((inputs: Settings_Cancel_DoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_DoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_done(inputs)
	return en_settings_cancel_done(inputs)
});